const phoneRegex = /^(?:\+91[-\s]?|91[-\s]?|0)?[1-9]\d{9}$/; // Only numbers, exactly 10 digits

export const loginSchema = () => {
    return(
        {
            phone: {
                type: 'text',
                label: 'Phone Number',
                validation: (value) => {
                    if (value.trim() === '') return 'Phone Number is required';
                    if (!phoneRegex.test(value)) return "Please enter a valid Indian phone number (e.g. 9876543210, +919876543210, 01722001234)";
                    return null;
                },
            },
            password: {
                type: 'password',
                label: 'Password',
                validation: (value) => {
                    if (value.trim() === '') return 'Password is required';
                    return null;
                },
            }
        }
    )
}
